import styled from 'styled-components/macro';

import FlexContainer from 'components/FlexContainer/FlexContainer';

export const BannerCardWrapStyled = styled.div`
  position: relative;
  z-index: 1;
  min-width: 288px;
  height: 230px;
  min-height: 230px;
  max-height: 230px;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  flex: 1 1 288px;
  display: flex;
  flex-direction: column;
  overflow: visible;

  @media screen and (max-width: 768px) {
    height: auto;
    min-height: 0;
    max-height: none;
    width: 100%;
    flex: 1 1 auto;
  }
  @media screen and (max-width: 424px) {
    height: auto;
    min-height: 0;
    max-height: none;
    width: 100%;
    flex: 1 1 auto;
  }

  & > div {
    flex: 1;
    min-height: 0;
    height: 100%;
    max-height: 100%;
    width: 100%;
    min-width: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    overflow: visible;
  }

  @media screen and (max-width: 768px) {
    & > div {
      height: auto;
      max-height: none;
      flex: 0 0 auto;
      align-self: flex-start;
    }
  }
  @media screen and (max-width: 424px) {
    & > div {
      height: auto;
      max-height: none;
      flex: 0 0 auto;
      align-self: flex-start;
    }
  }
`;

export const MessagesStackStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  width: 100%;
  padding-right: 12px;
`;

export const BannerContentWrapStyled = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  width: 100%;
  align-items: stretch;
`;

export const MessageBubbleStyled = styled(FlexContainer)<{ $stackItem?: boolean }>`
  flex: ${({ $stackItem }): string => ($stackItem ? '0 0 auto' : '1')};
  min-width: 0;
  min-height: 0;
  padding: 8px 10px;
  border-radius: 8px;
  background-color: ${({ theme }): string =>
    theme.mode === 'dark' ? theme.colors.highlight.variant6 : '#E5F6FD'};
  border: ${({ theme }): string =>
    `1px solid ${theme.mode === 'dark' ? theme.colors.primary.variant5 : '#CED4DA'}`};
  box-sizing: border-box;
  color: ${({ theme }): string =>
    theme.mode === 'dark' ? theme.colors.primary.variant11 : '#014361'};
  overflow-y: ${({ $stackItem }): string => ($stackItem ? 'visible' : 'auto')};
  align-items: flex-start;

  & > *:last-child {
    min-width: 0;
    word-break: break-word;
    white-space: normal;
  }

  ${({ theme }): string =>
    theme.mode === 'dark'
      ? `
    &, & *, & a {
      color: ${theme.colors.white} !important;
    }
  `
      : ''}
`;
